<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table
        class="table mg-b-0 table-contact product-table supplier data-table"
      >
        <thead>
          <tr>
            <th class="wd-lg-500">
              <label class="ckbox mg-b-0 d-inline-block valign-middle">
                <input
                  type="checkbox"
                  :checked="isAll"
                  @change="changeAllCheck($event)"
                />
                <span></span>
              </label>
              {{ $t("product.商品信息") }}
            </th>
            <th class="wd-lg-250">{{ $t("product.商品分类") }}</th>
            <th class="wd-lg-150">{{ $t("product.状态") }}</th>
            <th class="wd-lg-150">{{ $t("product.客户反馈") }}</th>
            <th class="wd-lg-250">
              <div class="d-flex">
                <span>{{ $t("product.创建时间") }}</span>
                <a
                  href="javascript:;"
                  class="mg-l-5 sp-dd d-inline-block"
                  :class="{
                    'tx-info': sortType2 == 'timeCreated',
                    'tx-gray-500': sortType2 != 'timeCreated',
                    up: sorts2 == 'timeCreated ASC',
                  }"
                  @click="sortList('timeCreated')"
                  data-toggle="tooltip"
                  data-placement="right"
                  :data-original-title="$t('product.按创建时间排序')"
                  >▼</a
                >
                <span class="mg-l-2 mg-r-2">/</span>
                <span>{{ $t("product.更新时间") }}</span>
                <a
                  href="javascript:;"
                  class="mg-l-5 sp-dd d-inline-block"
                  :class="{
                    'tx-info': sortType2 == 'timeUpdate',
                    'tx-gray-500': sortType2 != 'timeUpdate',
                    up: sorts2 == 'timeUpdate ASC',
                  }"
                  @click="sortList('timeUpdate')"
                  data-toggle="tooltip"
                  data-placement="right"
                  :data-original-title="$t('product.按更新时间排序')"
                  >▼</a
                >
              </div>
            </th>
            <th class="wd-lg-100">{{ $t("product.操作") }}</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in items" :key="index + item.id">
          <tr>
            <td class="valign-middle tx-12">
              <div
                class="media d-flex align-items-center pos-relative"
                style="white-space: nowrap"
              >
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" :value="item.sku" v-model="checkArr" />
                  <span></span>
                </label>
                <div class="mg-r-10 pos-relative img-wraps">
                  <template>
                    <div
                      v-if="item.propertyImage && item.propertyImage.length > 1"
                      class="num"
                    >
                      {{ item.propertyImage.length }}
                    </div>
                    <a
                      v-if="item.propertyImage && item.propertyImage.length"
                      class="p-img-wrap"
                      :class="{ isIll: $isIll(item.propertyImage) }"
                      v-lazy:background-image="item.propertyImage[0]"
                      href="javascript:;"
                      @click="preview(item.propertyImage, item.name)"
                    >
                    </a>
                    <a
                      v-else
                      class="p-img-wrap"
                      :class="{ isIll: $isIll(item.propertyImage) }"
                      v-lazy:background-image="item.propertyImage"
                      href="javascript:;"
                    >
                    </a>
                  </template>
                  <div
                    v-if="item.propertyImage && item.propertyImage.length > 1"
                    class="mult-img-bg"
                  ></div>
                  <!--<a v-if="item.status != 2 && item.status != 3" 
                      @click="mgrImg(item)" 
                      href="javascript:;" 
                      class="img-mgr btn btn-primary btn-sm tx-12 pos-absolute op-7"
                    >
                      $t('product.图片管理')
                    </a>  -->
                </div>
                <!--<a
                  class="p-img-wrap"
									:class="{isIll: $isIll(item.propertyImage)}"
                  v-lazy:background-image="item.propertyImage"
                  href="javascript:;"
                	>
                </a>-->
                <div class="info">
                  <div class="mg-b-0 tx-white tx-ellipsis2">
                    <a
                      v-if="item.shopDetailUrl && item.shopDetailUrl != ''"
                      :href="item.shopDetailUrl"
                      target="_blank"
                      class="tx-info"
                      >{{ item.name }}</a
                    >
                    <p v-else class="mg-b-0 tx-white">{{ item.name }}</p>
                  </div>
                  <div>
                    <a
                      v-if="item.fromUrl"
                      class="mg-l-5 tx-info"
                      :href="item.fromUrl"
                      target="_blank"
                      >{{ $t("product.原链接") }}</a
                    >
                  </div>
                  <div class="mg-b-0 d-flex">
                    <span>{{ $t("product.商品货号(SKU)：") }}</span>
                    <span class="tx-white">{{
                      item.sku ? item.sku : "--"
                    }}</span>
                  </div>
                  <div class="mg-b-0 d-flex">
                    <span>{{ $t("product.供货价：") }}</span>
                    <span class="tx-white"
                      >{{ ($CE[item.currency] || {}).symbol
                      }}{{
                        item.salePrice
                          ? Number(item.salePrice).toFixed(2)
                          : "0.00"
                      }}</span
                    >
                  </div>
                  <!--<div class=" mg-b-0 d-flex">
	                    <span style="min-width: 65px;">包含颜色$t('product.：')</span>
	                    <span class=" tx-white">{{item.colors}}</span>
	                  </div>
	                   <div v-if="!(userinfo.productStyle == 9999)" class=" mg-b-0 d-flex">
                    	<span>销售$t('product.状态')$t('product.：')</span>
			                <span :class="statusStyle[item.productStatus]" >
												{{$dict.newProSoldStatus[item.productStatus]}}
											</span>
			              </div>-->
                  <div v-if="item.productStatus == 1" class="mg-b-0 d-flex">
                    <span>{{ $t("product.上架时间：") }}</span>
                    <span class="tx-white">{{
                      item.timeOff ? timeOff : "---"
                    }}</span>
                  </div>
                  <div v-if="item.productStatus == 2" class="mg-b-0 d-flex">
                    <span>{{ $t("product.下架时间：") }}</span>
                    <span class="tx-white">{{
                      item.timeSale ? timeSale : "---"
                    }}</span>
                  </div>
                  <div class="mg-b-0 d-flex">
                    <span>{{ $t("product.最后更新时间：") }}</span>
                    <span class="tx-white">{{
                      item.timeLastUpdate ? item.timeLastUpdate : "---"
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-0 d-flex">
                <span class="tx-white">{{
                  item.categoryName ? item.categoryName : "---"
                }}</span>
              </div>
            </td>
            <td class="valign-middle tx-12">
              <span :class="item.status | statusClass">{{
                $t($dict.newProStatus[item.status])
              }}</span>
            </td>
            <td class="valign-middle tx-12">
              <a
                v-if="item.reason && item.reason.length"
                class="pd-5 tx-info"
                href="javascript:;"
                data-container="body"
                data-toggle="tooltip-primary"
                data-placement="top"
                data-html="true"
                :data-original-title="item.reason"
              >
                <i class="icon ion-chatbox-working tx-20 tx-info"></i>
              </a>
              <a v-else href="javascript:;">
                <i class="icon ion-chatbox-working tx-20 tx-gray-600"></i>
              </a>
            </td>
            <td class="valign-middle tx-12">
              <div class="tx-white">
                <span class="tx-gray-600">{{ $t("product.创建时间：") }}</span>
                {{ item.timeCreated ? item.timeCreated : "---" }}
              </div>
              <div class="tx-white">
                <span class="tx-gray-600">{{ $t("product.更新时间：") }}</span>
                {{ item.timeLastUpdate ? item.timeLastUpdate : "---" }}
              </div>
            </td>
            <td class="valign-middle tx-12">
              <div class="mg-b-5">
                <a
                  v-if="item.status == 1"
                  class="tx-info"
                  href="javascript:;"
                  @click="channelType(item)"
                  >{{ $t("product.推送给客户") }}</a
                >
              </div>
              <div v-if="item.status != 2 && item.status != 3" class="mg-b-5">
                <router-link
                  class="tx-info"
                  target="_blank"
                  :to="{ name: 'createProPage', query: { id: item.id } }"
                  >{{ $t("product.修改") }}</router-link
                >
              </div>
              <div v-if="item.status == 1">
                <a
                  class="tx-danger"
                  href="javascript:;"
                  @click="delNewProduct(item)"
                  >{{ $t("product.删除") }}</a
                >
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="(!items || items.length < 1) && !first_loading">
          <tr>
            <td colspan="5">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i
                >{{ $t("product.没有符合条件的合作SKU") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ["items", "first_loading", "sort2", "sort_type2", "check_arr"],
  data() {
    return {
      sorts2: "",
      sortType2: "timeCreated",
      checkArr: [],
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      statusStyle: {
        1: "tx-success",
        2: "tx-danger",
        9: "tx-warning",
      },
    };
  },
  computed: {
    isAll() {
      return this.checkArr.length == this.items.length && this.items.length > 0
        ? true
        : false;
    },
  },
  watch: {
    sort_type2: function () {
      this.sortType2 = this.sort_type2;
    },
    sort2: function () {
      this.sorts2 = this.sort2;
    },
    check_arr: function () {
      this.checkArr = this.check_arr;
    },
    checkArr: function () {
      this.$emit("changeChecked", this.checkArr);
    },
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary tooltip-special" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
    //  $('.tooltip-primary.tooltip-special').on('shown.bs.tooltip', function () {
    //  	console.log(1)
    //		  $('.tooltip-primary.tooltip-special').css("top","-60px")
    //		})
  },
  filters: {
    statusClass(val) {
      let c = "";
      switch (val) {
        case "1":
          c = "tx-warning";
          break;
        case "2":
        case "3":
          c = "tx-success";
          break;
        case "4":
          c = "tx-danger";
          break;
        case "9":
          c = "tx-white";
          break;
        default:
          break;
      }
      return c;
    },
  },
  methods: {
    mgrImg(item, sku, max) {
      this.$emit("mgrImg", item, sku, max);
    },
    preview(img, text) {
      if (!img) return;
      this.$parent.loading = true;
      let imgArr = [];
      img.forEach((e) => {
        imgArr.push({
          img: e,
          text,
        });
      });
      this.$store.commit("setImgItem", imgArr);
      setTimeout(() => {
        const viewer = document.querySelector(".app-images-arr").$viewer;
        viewer.show();
        this.$parent.loading = false;
      }, 500);
    },
    channelType(item) {
      this.$emit("channelType", item);
    },
    sortList(type) {
      $('[data-toggle="tooltip"]').tooltip("hide"); //$t('product.关闭所有') tooltip
      switch (type) {
        case "name":
          if (!this.sorts2) {
            this.sorts2 = "name DESC";
          } else {
            if (this.sorts2 == "name DESC") {
              this.sorts2 = "name ASC";
            } else {
              this.sorts2 = "name DESC";
            }
          }
          break;
        case "timeUpdate":
          if (!this.sorts2) {
            this.sorts2 = "timeUpdate DESC";
          } else {
            if (this.sorts2 == "timeUpdate DESC") {
              this.sorts2 = "timeUpdate ASC";
            } else {
              this.sorts2 = "timeUpdate DESC";
            }
          }
          break;
        case "timeCreated":
          if (!this.sorts2) {
            this.sorts2 = "timeCreated ASC";
          } else {
            if (this.sorts2 == "timeCreated DESC") {
              this.sorts2 = "timeCreated ASC";
            } else {
              this.sorts2 = "timeCreated DESC";
            }
          }
          break;
      }
      this.$emit("sortList", type, this.sorts2);
    },
    getHtml(item) {
      if (!item) return;
      let arr = item.split("|");
      let html = "";
      html = `<span>${arr[0]}<br/>${arr[1]}</span>`;
      return html;
    },
    changeAllCheck(e) {
      this.checkArr = [];
      if (e.target.checked) {
        this.items.forEach((e) => {
          this.checkArr.push(e.sku);
        });
      }
    },
    isEmpty(obj) {
      if (
        typeof obj == "undefined" ||
        obj == null ||
        obj == "" ||
        obj == "null"
      ) {
        return true;
      } else {
        return false;
      }
    },
    imgUrlFormat(value) {
      if (!this.isEmpty(value)) {
        return JSON.parse(value);
      }
    },
    remarkFormat(r) {
      //$t('product.备注格式化成')html
      if (!r || r.length == 0) return;
      let html = "";
      r.forEach((e) => {
        html += `<p class="mg-b-5">${e}</p>`;
      });
      return html;
    },
    delNewProduct(item) {
      this.$emit("delNewProduct", item);
    },
  },
};
</script>
<style>
.p-img-wrap {
  width: 80px;
  height: 80px;
  display: block;
}
th a.sp-dd:hover {
  color: #05407c !important;
}
th a.sp-dd.tx-info:hover {
  color: #148ea1 !important;
}
.pos-relative.img-wraps {
  width: 100px;
  height: 100px;
  min-width: 100px;
}
.pos-relative .num {
  position: absolute;
  top: 0;
  right: 5px;
  z-index: 2;
  background-color: #1caf9a;
  color: #fff;
  padding: 0 3px;
  height: 18px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 18px;
}
.pos-relative .p-img-wrap {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin-right: 0;
  background-color: #fff;
  /*-webkit-transform: scale(.9);
    transform: scale(.9);*/
  border: 1px solid #161f2b;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  width: 100px;
  height: 100px;
}
.pos-relative .mult-img-bg {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 100px;
  height: 100px;
  /*-webkit-transform: scale(.9);
    transform: scale(.9);*/
  background: #666;
  border: 1px solid #333;
}
.white-body .pos-relative .mult-img-bg {
  background: #e6e6e6;
}
.img-mgr {
  bottom: 5px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
}
th a.sp-dd.tx-info:hover {
  color: #148ea1 !important;
}
.fixed-page .br-pagebody .body-wrap {
  overflow-y: scroll;
}
.sp-dd::before {
  z-index: 1 !important;
}
</style>
